export default {
  get name(): string {
    return 'ExponentImageManipulator';
  },
};
